module.exports = __webpack_public_path__ + "93d6475bd2581cb5aa1b527aa8152a95.svg";